import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-digit-shuffle',
  templateUrl: './digit-shuffle.component.html',
  styleUrls: ['./digit-shuffle.component.scss']
})
export class DigitShuffleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
